const events: {
    [key: string]: Array<Function>
} = {}

export function registerEventCallback(eventName: string, callback: Function) {
    if (!events[eventName]) {
        events[eventName] = []
    }
    events[eventName].push(callback)
}

export function emitEvent(eventName: string, data?: any) {
    const callbacks = events[eventName]
    if (callbacks) {
        callbacks.forEach((cb: Function) => {
            cb(data)
        })
    }
}

export function unregisterEventCallback(eventName: string, callback: Function) {
    const callbacks = events[eventName]
    if (callbacks) {
        events[eventName] = callbacks.filter((cb: Function) => cb !== callback)
    }
}

export function unregisterAllEventCallbacks(eventName: string) {
    delete events[eventName]
}

export function evokeCallbacks(eventName: string, data: any) {
    const callbacks = events[eventName]

    let returnValues: boolean[] = []
    if (callbacks) {
        callbacks.forEach((cb: Function) => {
            returnValues.push(cb(data))
        })
    }
    return returnValues.some(Boolean)
}

export function checkForRegisteredEvents(eventName: string) {
    const callbacks = events[eventName]
    if (callbacks && callbacks?.length > 0) {
        return true
    }
    return false
}
